import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';

export default function K() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_double');
    const getImagePath = () => {
        if (locale === 'mx') {
            return {
                src: 'https://websiteoss.ecoflow.com/upload/image/1747053322114/new-220w.jpg',
                srcPad: 'https://websiteoss.ecoflow.com/upload/image/1747053424150/new_220_M.jpg',
                srcMobile: 'https://websiteoss.ecoflow.com/upload/image/1747053424150/new_220_M.jpg',
            };
        }

        if (locale === 'br') {
            return {
                src: 'https://websiteoss.ecoflow.com/upload/image/1742975239117/11_1_br.png',
                srcPad: 'https://websiteoss.ecoflow.com/upload/image/1742975238927/11_1_768_br.png',
                srcMobile: 'https://websiteoss.ecoflow.com/upload/image/1742975238927/11_1_768_br.png',
            };
        }
        if (locale === 'kr') {
            return {
                src: 'https://websiteoss.ecoflow.com/upload/image/1747293052963/kr-pc.jpg',
                srcPad: 'https://websiteoss.ecoflow.com/upload/image/1747293063209/kr-m.jpg',
                srcMobile: 'https://websiteoss.ecoflow.com/upload/image/1747293063209/kr-m.jpg',
            };
        }

        return {
            src: `/responsive/picture/solar-panel-220w-double/11_1_${locale}.jpg`,
            srcPad: `/responsive/picture/solar-panel-220w-double/11_1_768_${locale}.jpg`,
            srcMobile: `/responsive/picture/solar-panel-220w-double/11_1_768_${locale}.jpg`,
        };
    };

    const imagePaths = getImagePath();

    return (
        <div className="sp-220-double-K">
            <div className="info-box">
                <p className="title">{t('K_title')}</p>
                <p className="desc">{t('K_desc')}</p>
            </div>
            <div className="img-boxs">
                <EFPicture src={imagePaths.src} srcPad={imagePaths.srcPad} srcMobile={imagePaths.srcMobile} alt={t('K_title')} />
                <EFPicture
                    src="/responsive/picture/solar-panel-220w-double/11_2.jpg"
                    srcPad="/responsive/picture/solar-panel-220w-double/11_2_768.jpg"
                    srcMobile="/responsive/picture/solar-panel-220w-double/11_2_768.jpg"
                    alt={t('K_title')}
                />
            </div>
        </div>
    );
}
